import { Component, Renderer2 } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, NavigationEnd } from "@angular/router";
import { ApplicationUtilsService } from "./global_services/application_utils/application_utils.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export class AppComponent {
  header: string;
  footer: string;

  constructor(
    private router: Router,
    private title: Title,
    private appService: ApplicationUtilsService,
    private renderer: Renderer2
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const header = this.getHeader(event.url);
        this.header = header;
        const footer = this.getFooter(event.url);
        this.footer = footer;
        if (header != null) {
          this.title.setTitle(header + " | NVWA");
        } else {
          this.title.setTitle("NVWA");
        }
      }
    });
    // Class hidden toevoegen zodat in de index.html de loading-spinner uitgezet kan worden.
    const element = document.querySelector(".loading");
    if (element) {
      this.renderer.addClass(element, "hidden");
    }

    //  $("body .loading").addClass("hidden");
  }

  getHeader(url): string {
    return this.getPrompt("COV_CERTIFICAAT.CONTROLEER_CERTIFICAAT");
  }

  getFooter(url): string {
    switch (url) {
      case "/checkCertificate":
        return "Check certificate";
    }
  }

  getPrompt(prompt) {
    return this.appService.getPrompt(prompt);
  }
}
